import * as React from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { AgreementLevel } from "src/components/Agreement";
import { ReactComponent as High } from "src/images/agreement/high.svg";
import { ReactComponent as Low } from "src/images/agreement/low.svg";
import { ReactComponent as Mid } from "src/images/agreement/mid.svg";
import {
  AgreementProgressWrapper,
  AgreementUnderline,
  AgreementWrapper,
  BirdWrapper,
} from "./Agreement.components";

interface Props {
  value: number;
}

const Agreement: React.FunctionComponent<Props> = ({ value }) => {
  const [agreementLevel, setAgreementLevel] =
    React.useState<AgreementLevel>("mid");
  // this is for progress fill animation when component loads for the first time
  const [actualValue, setActualValue] = React.useState<number>(0);

  const birds = {
    low: <Low data-agreement="low" />,
    mid: <Mid data-agreement="mid" />,
    high: <High data-agreement="high" />,
  };

  React.useEffect(() => {
    setActualValue(value);
  }, [value]);

  React.useEffect(() => {
    if (actualValue > 70) {
      setAgreementLevel("high");
    } else if (actualValue > 30) {
      setAgreementLevel("mid");
    } else {
      setAgreementLevel("low");
    }
  }, [actualValue]);

  return (
    <AgreementWrapper data-cy="agreementMeter">
      <AgreementProgressWrapper>
        <CircularProgressbarWithChildren
          value={actualValue}
          circleRatio={0.5}
          styles={buildStyles({ rotation: 3 / 4, strokeLinecap: "butt" })}>
          <BirdWrapper>
            <div>{birds[agreementLevel]}</div>
          </BirdWrapper>
        </CircularProgressbarWithChildren>
      </AgreementProgressWrapper>
      <AgreementUnderline />
    </AgreementWrapper>
  );
};

export default Agreement;
